import { aiTriageHome, registerAiTriageHome } from "../src/aiTriageHome";
import { bootAiTriageHome } from "../src/aiTriageHomeBoot";

// Always expose the factory. The pack is only included on the flag-on
// homepage; do not wait for #ai-triage-card-host or window.Alpine — both
// can be missing when this script evaluates (script is above the host,
// or this pack is listed before application.js).
bootAiTriageHome(registerAiTriageHome, aiTriageHome);
